import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { useTranslation } from "react-i18next";
import { requestQuotations, unloadQuotations, updateFilters } from "../../../data/account/actions/quotation";
import { statusName } from "../../../data/booking/constants/quotation_status";
import { getQuotations } from "../../../data/account/selectors/quotation";
import TripItemsList from "./TripItemsList";
import Filter from "./Filter";
import moment from 'moment';
import { Desktop } from "../../shared/components/Responsive";
import { FormHeading } from "../../shared/components/Typograhy";
import SlideInAnimation from "../../shared/components/SlideInAnimation";
import { quotationStatus } from "../../../data/account/constants/status_types";

import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function QuotationList() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [show, setShow] = useState(false);
    const [filteredTrips, setFilteredTrips] = useState([]);
    const { filters, entities, isFetching, reachedEnd } = useSelector(state => state.account.quotation);

    useEffect(() => {
        dispatch(unloadQuotations());
        loadBookings();
        setShow(true);
        return()=>{
            disableScrollHandler();
            dispatch(unloadQuotations());
        }
    }, [])

    useEffect(() => {
        if(!isFetching) {
            setFilteredTrips(getQuotations(entities));
        }
    }, [entities.quotations]);

    const loadBookings = (reset = null) => {
        let promise = dispatch(requestQuotations(reset));
        if(promise){
            promise.then(() => {
                enableScrollHandler()
            });
        }
        return promise;
    }

    const loadMore = () => {
        if (isFetching) {
            return;
        }
        disableScrollHandler();
        loadBookings();
    }

    let handleScroll = () => {
        if (isFetching || reachedEnd) {
            return;
        }

        const { scrollHeight, clientHeight } = document.documentElement;
        const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
        const trigger = scrollHeight - (scrollTop + clientHeight) < 150;

        if (trigger) {
            loadMore();
        }
    }

    const enableScrollHandler = () => {
        window.addEventListener('scroll', handleScroll);
    }

    const disableScrollHandler = () => {
        window.removeEventListener('scroll', handleScroll);
    }
    
    return (
        <>
            <FormHeading
                title={t("account_button.quotations")}
                subtitle={t('account_button.subtitle_quotations')}
            />

            <Filter filters={filters} type={updateFilters} status={quotationStatus.map((status) => ({id: status.value, title: t(status.label)}))} />

            <div className={"mb-4 flex justify-end relative bottom-3"}>
                <Desktop>
                    {filters.date.from &&
                        <div className="flex gap-3 items-center bg-gray-200 p-2 rounded-b-lg px-2 text-sm text-gray-800 shadow-md">
                            {moment(filters.date.from).format("DD MMM YYYY")}
                            {filters.date.to && " - "}
                            {filters.date.to && moment(filters.date.to).format("DD MMM YYYY")}
                        </div>
                    }
                </Desktop>
            </div>

            {!isEmpty(filteredTrips) ?
                <SlideInAnimation show={show} appear={true}>
                   <TripItemsList trips={filteredTrips} editable={false}  endUser={true} translationFor={t('account_button.the_quotation')} translationDetails={t('account_button.detailsQuotation')} statusName={statusName} />
                </SlideInAnimation>
            : !isFetching ? <>
                <p>{t('account.no_quotations')}</p>
            </>
            : <></>}

            {isFetching &&
            <div className="h-[50vh] overflow-hidden flex justify-center items-center">
                <FontAwesomeIcon icon={faCircleNotch} className={"h-10 w-10 text-gray-300 self-center"} spin />
                <p className="ml-4 text-lg text-gray-800">{t('shared.loading')}...</p>
            </div>}
        </>
    );
}
